export default __webpack_public_path__ + "static/media/bogged-logo.719aa960.png";